import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';

interface MetricCardProps {
  label: string;
  value: string;
  delta: string;
  trend: 'up' | 'down' | 'flat';
  helper: string;
  iconLabel: string;
}

const trendTone = {
  up: 'success' as const,
  down: 'error' as const,
  flat: 'info' as const,
};

export default function MetricCard({ label, value, delta, trend, helper, iconLabel }: MetricCardProps) {
  const tone = trendTone[trend];

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 3,
                display: 'grid',
                placeItems: 'center',
                backgroundColor: 'rgba(20, 63, 107, 0.1)',
                color: 'primary.main',
                fontWeight: 800,
                fontSize: 13,
              }}
            >
              {iconLabel}
            </Box>

            <Chip
              size="small"
              label={delta}
              color={tone}
              variant="outlined"
              sx={{ fontWeight: 700 }}
            />
          </Stack>

          <Stack spacing={0.5}>
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
            <Typography variant="h4">{value}</Typography>
            <Typography variant="body2" color="text.secondary">
              {helper}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}